import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getLearningCourseStandardsQuery,
  getPublishedSubjectStandardDetailsQuery,
  getStandardSetsQuery,
} from "./StandardsSelectionModalQueries";

export const getPublishedSubjectStandardDetailsFromCache = variables => {
  try {
    const data = client.readQuery({
      query: getPublishedSubjectStandardDetailsQuery,
      variables,
    });

    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const getLearningCourseStandardsFromCache = variables => {
  try {
    const data = client.readQuery({
      query: getLearningCourseStandardsQuery,
      variables,
    });

    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStandardSetsFromCache = variables => {
  try {
    const data = client.readQuery({
      query: getStandardSetsQuery,
      variables,
    });

    return _.get(data, "node", {});
  } catch (e) {
    return {};
  }
};
